module.exports = __webpack_public_path__ + "static/img/Coming_Home_FPO.ca8a457.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pride/Coming_Home_FPO.jpg
// module id = JxxA
// module chunks = 0